/*
|-------------------------------------------------------------------------------
| VUEX modules/apps.jss
|-------------------------------------------------------------------------------
| The Vuex data store for the apps
*/

import APP_API from '../../api/apiapps.js';

export const api_apps = {
    state: {
        apps: [],
        appsLoadStatus: 0,

        app: {},
        appLoadStatus: 0,

        appCreatedStatus: 0
    },

//https://serversideup.net/build-vuex-module/

    /*
    * * status = 0 -> No loading has begun
    * status = 1 -> Loading has started
    * status = 2 -> Loading completed successfully
    * status = 3 -> Loading completed unsuccessfully
    *
    * */
    /*
          Defines the actions used to retrieve the data.
        */
    actions: {
        /*
          Loads the apps from the API
        */
        loadApps({commit}) {
            commit('setAppsLoadStatus', 1);
            commit('setLoadingStatus', true);
            APP_API.getApps()
                .then(function (response) {
                    commit('setApps', response.data.data);
                    commit('setAppsLoadStatus', 2);
                    commit('setLoadingStatus', false);
                })
                .catch(function () {
                    commit('setApps', []);
                    commit('setAppsLoadStatus', 3);
                });
        },

        /*
          Loads an individual app from the API
        */
        loadApp({commit}, data) {
            commit('setAppLoadStatus', 1);

            APP_API.getApp(data.id)
                .then(function (response) {
                    commit('setApp', response.data.data);
                    commit('setAppLoadStatus', 2);
                })
                .catch(function () {
                    commit('setApp', {});
                    commit('setAppLoadStatus', 3);
                });
        },

        /*
        Loads an individual app from the API
      */
        revokeApiApp({commit, dispatch}, data) {
            commit('setAppLoadStatus', 1);

            APP_API.revokeApp(data.id)
                .then(function (response) {
                    dispatch('loadApps');
                    commit('setAppLoadStatus', 2);
                })
                .catch(function () {
                    commit('setAppLoadStatus', 3);
                });
        },

        /*
         Creates an App through the API
       */
        createNewApp({commit}, data) {
            commit('setAppLoadStatus', 1);

            return APP_API.postCreateApp(data)
                .then(function (response) {
                    commit('setApp', response.data.data);
                    commit('setAppLoadStatus', 2);

                    return response;
                })
                .catch((error) => {
                    if(error.status === 422 && error.response) {
                        commit('setValidationErrors', error.response.data)
                    }
                    commit('setApp', {});
                    commit('setAppLoadStatus', 3);
                });
        },
    },

    /*
      Defines the mutations used
    */
    mutations: {
        /*
          Sets the apps load status
        */
        setAppsLoadStatus(state, status) {
            state.appsLoadStatus = status;
        },

        /*
          Sets the apps
        */
        setApps(state, apps) {
            state.apps = apps;
        },

        /*
          Set the app load status
        */
        setAppLoadStatus(state, status) {
            state.appLoadStatus = status;
        },

        /*
          Set the app
        */
        setApp(state, app) {
            state.app = app;
        },

        /*
         Set the app created status
       */
        setAppCreatedStatus(state, status) {
            state.appCreatedStatus = status;
        }
    },

    /*
      Defines the getters used by the module
    */
    getters: {
        /*
          Returns the apps load status.
        */
        getAppsLoadStatus(state) {
            return state.appsLoadStatus;
        },

        /*
          Returns the apps.
        */
        getApps(state) {
            return state.apps;
        },

        /*
          Returns the apps load status
        */
        getAppLoadStatus(state) {
            return state.appLoadStatus;
        },

        /*
          Returns the app
        */
        getApp(state) {
            return state.app;
        },

        /*
         Returns the apps load status.
       */
        getAppCreatedStatus(state) {
            return state.appCreatedStatus;
        },
    }
}
